import { render } from "./Massage.vue?vue&type=template&id=e2b0a1fa&scoped=true"
import script from "./Massage.vue?vue&type=script&lang=js"
export * from "./Massage.vue?vue&type=script&lang=js"

import "./Massage.vue?vue&type=style&index=0&id=e2b0a1fa&lang=css"
import "./Massage.vue?vue&type=style&index=1&id=e2b0a1fa&scoped=true&lang=css"
import "./Massage.vue?vue&type=style&index=2&id=e2b0a1fa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b0a1fa"]])

export default __exports__